/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconGraph(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <g fill="currentColor" clipPath="url(#a)">
        <path d="M15.333 14.667h-12a2 2 0 0 1-2-2v-12A.667.667 0 1 0 0 .667v12A3.337 3.337 0 0 0 3.333 16h12a.666.666 0 1 0 0-1.333" />
        <path d="M4 13.333a.667.667 0 0 0 .667-.666V8a.667.667 0 0 0-1.334 0v4.667a.667.667 0 0 0 .667.666M6.667 6.667v6a.667.667 0 0 0 1.333 0v-6a.667.667 0 0 0-1.333 0M10 8.667v4a.667.667 0 1 0 1.333 0v-4a.667.667 0 1 0-1.333 0M13.333 6v6.667a.667.667 0 1 0 1.334 0V6a.666.666 0 1 0-1.334 0M4 6c.177 0 .346-.07.471-.195l2.391-2.391a.683.683 0 0 1 .943 0l1.448 1.448a2 2 0 0 0 2.828 0l3.724-3.724a.667.667 0 0 0-.943-.943L11.138 3.92a.667.667 0 0 1-.943 0L8.747 2.47a2 2 0 0 0-2.828 0L3.53 4.862A.667.667 0 0 0 4 6" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
